//
//
//
//
//
//
//
//
//

import { ModalContainer } from "@/components/modal";
import { mapMutations } from "vuex";
import Cookies from "@/utils/cookie";

export default {
  components: {
    "c-modal-container": ModalContainer,
  },
  methods: {
    ...mapMutations(["setInfo", "setPageHidden"]),
  },
  created() {
    // 创建一个 URL 对象
    const params = new URLSearchParams(new URL(location.href).search);
    // 获取参数值
    const code = params.get("code");
    if (code) {
      // 单点登录
      const url = configs.autoLoginURL;
      const data = {
        grant_type: "authorization_code",
        client_id: "jhskins",
        code: code,
        redirect_uri: location.origin,
      };
      const formBody = Object.keys(data)
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
        .join("&");

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      })
        .then((response) => response.json())
        .then((data) => {
          console.error("单点登录：", data);
          Cookies.setToken(res.data.authToken);
          setTimeout(() => {
            this.setInfo();
          }, 500);
        });
    }
  },
  mounted() {
    const that = this;

    //清除之前的localStorage的authToken和user
    const authToken = localStorage.getItem("authToken");
    const user = JSON.parse(localStorage.getItem("user"));
    if (authToken) {
      localStorage.removeItem("authToken");
    }
    if (user) {
      localStorage.removeItem("user");
    }
    this.$mpCaseHub.initHub();
    this.$chatRoomHub.initHub();
    //this.$crashHub.initHub(0);

    // 监听标签页的可见性变化
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {
        that.setPageHidden(false);
      } else {
        that.setPageHidden(true);
      }
    });
  },
};
